import React, { Fragment } from 'react';
import { Accordion, Button, Form, Grid, Header, Icon } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import ReactTable from 'Common/ReactTableWrapper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { SiteComponent } from 'Common/SiteComponent';
import { DatePickerField } from 'Common/SemanticWrapper';
import { DatePickerCustomButton } from 'Components';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { CK_KITCHEN_PREP_WORKSHEET_FORM_NAME } from 'Common/FormEnum';
import { KitchenPrepWorksheetEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

import {
  viewStatusOptions,
  printOptions,
} from './../../helper/createEditPrepWorksheet';

const KitchenPrepWorksheetComponent = props => {
  const {
    activeIndexForFilter,
    activeIndexForSort,
    handleClick,
    setShowStatusOption,
    printKitchenData,
    columns,
    reactTableRef,
    kitchenPrepWorksheetItems,
    fetchKitchenPrepWorksheetLoading,
    isDisabled,
    wHKITListData,
    onChangeOfFromDT,
    onChangeOfToDT,
    fromDateMax,
    toDateMin,
    dropDownChange,
    clearFilters,
    printLoading,
  } = props;

  return (
    <Fragment>
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Accordion fluid styled>
                <Accordion.Title
                  active={!activeIndexForFilter}
                  onClick={handleClick}
                  index={0}
                  option={0}
                >
                  <Icon name="dropdown" />
                  <span className="text-orange">Filter By</span>
                </Accordion.Title>
                <Accordion.Content active={!activeIndexForFilter}>
                  <Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column width={8}>
                        <div style={{ paddingTop: 25 }}>
                          <Header as="h4">Delivery Date Range</Header>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={4}>
                      <Grid.Column>
                        <Field
                          component={DatePickerField}
                          customInput={<DatePickerCustomButton />}
                          label={'From:'}
                          dateFormat={DATE_FORMAT_FOR_UI}
                          name={KitchenPrepWorksheetEnum.BeginDT}
                          onChange={onChangeOfFromDT}
                          maxDate={fromDateMax}
                          type={'text'}
                          dropdownMode="select"
                          disabled={isDisabled}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Field
                          component={DatePickerField}
                          customInput={<DatePickerCustomButton />}
                          label={'To:'}
                          dateFormat={DATE_FORMAT_FOR_UI}
                          name={KitchenPrepWorksheetEnum.EndDT}
                          type={'text'}
                          onChange={onChangeOfToDT}
                          minDate={toDateMin}
                          dropdownMode="select"
                          disabled={isDisabled}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={2}>
                      <Grid.Column width={5}>
                        <div style={{ paddingTop: 25 }}>
                          <Header as="h4">Kitchen</Header>
                        </div>
                      </Grid.Column>
                      <Grid.Column>
                        <div style={{ paddingTop: 25 }}>
                          <Header as="h4">View Status</Header>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={4}>
                      <Grid.Column width={5}>
                        <SiteComponent
                          label={''}
                          name={KitchenPrepWorksheetEnum.WarehouseKitchen}
                          onChange={dropDownChange}
                          isForm={true}
                          siteMasterTypeIds={[SiteTypeEnum.Kitchen]}
                          style={{ marginBottom: 10 }}
                          checkIsLicensed={false}
                          siteOptions={wHKITListData}
                          isAllRequired={true}
                          isAllValueZero={true}
                          disabled={isDisabled}
                        />
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <ReduxFormButtonGroup
                          options={viewStatusOptions}
                          type={'button'}
                          formName={CK_KITCHEN_PREP_WORKSHEET_FORM_NAME}
                          fieldName={KitchenPrepWorksheetEnum.ViewStatusOptions}
                          onChange={setShowStatusOption}
                          disabled={isDisabled}
                        />
                      </Grid.Column>
                      <Grid.Column width={3}>
                        <Button
                          className={'clear-filters-button'}
                          content="Clear Filters"
                          onClick={clearFilters}
                          type={'button'}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Accordion.Content>
              </Accordion>

              <Accordion fluid styled>
                <Accordion.Title
                  active={!activeIndexForSort}
                  index={0}
                  option={1}
                  onClick={handleClick}
                >
                  <Icon name="dropdown" />
                  <span className="text-orange">Sort By</span>
                </Accordion.Title>
                <Accordion.Content active={!activeIndexForSort}>
                  <Grid>
                    <Grid.Row columns={2} className={'pt10'}>
                      <Grid.Column verticalAlign={'bottom'}>
                        <ReduxFormButtonGroup
                          options={printOptions}
                          formName={CK_KITCHEN_PREP_WORKSHEET_FORM_NAME}
                          fieldName={KitchenPrepWorksheetEnum.PrintOptions}
                          type={'button'}
                          disabled={isDisabled}
                        />
                      </Grid.Column>
                      <Grid.Column floated={'right'} textAlign={'right'}>
                        <Button
                          disabled={isDisabled}
                          loading={printLoading}
                          content="Print"
                          type={'button'}
                          style={{ marginLeft: 10 }}
                          onClick={printKitchenData}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Accordion.Content>
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row>
            <Grid.Column style={{ paddingTop: 20 }}>
              <ReactTable
                minRows={0}
                data={kitchenPrepWorksheetItems}
                noDatatext={'No rows found'}
                resizable={false}
                className="-striped -highlight"
                columns={columns}
                defaultFilterMethod={caseInsensitiveFilter}
                loading={fetchKitchenPrepWorksheetLoading}
                reactTableRef={reactTableRef}
                defaultPageSize={20}
                showPageSizeOptions={true}
                draggableColumns={true}
                showHideColumn={true}
                menu={'hasCogs'}
                saveState={{
                  tableName: TableNamesEnum.CK_KITCHEN_PREP_WORKSHEET_TABLE,
                }}
                hasSelectAllColumn={true}
                gridName={GridEnum.CK_Kitchen_Prep_Worksheet_View}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Fragment>
  );
};

KitchenPrepWorksheetComponent.propTypes = {
  activeIndexForFilter: PropTypes.number,
  activeIndexForSort: PropTypes.number,
  handleClick: PropTypes.func,
  setShowStatusOption: PropTypes.func,
  printKitchenData: PropTypes.func,
  columns: PropTypes.array.isRequired,
  reactTableRef: PropTypes.object,
  kitchenPrepWorksheetItems: PropTypes.array.isRequired,
  fetchKitchenPrepWorksheetLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  wHKITListData: PropTypes.array.isRequired,
  onChangeOfFromDT: PropTypes.func,
  onChangeOfToDT: PropTypes.func,
  fromDateMax: PropTypes.object,
  toDateMin: PropTypes.object,
  dropDownChange: PropTypes.func,
  clearFilters: PropTypes.func,
  printLoading: PropTypes.bool,
};

KitchenPrepWorksheetComponent.defaultProps = {
  activeIndexForFilter: 0,
  activeIndexForSort: 0,
  handleClick: () => {},
  setShowStatusOption: () => {},
  printKitchenData: () => {},
  fetchKitchenPrepWorksheetLoading: false,
  isDisabled: false,
  printLoading: false,
  reactTableRef: {},
  fromDateMax: null,
  toDateMin: null,
  onChangeOfFromDT: () => {},
  onChangeOfToDT: () => {},
  dropDownChange: () => {},
  clearFilters: () => {},
};

export default KitchenPrepWorksheetComponent;



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/components/kitchenPrepWorksheetListing/KitchenPrepWorksheet.js